<template>
    <v-row>
        <v-col>
            <v-stepper v-model="supportStepTracker">
                <v-stepper-header>
                    <v-stepper-step :complete="supportStep1Complete" step="1">
                        {{ $gettext('Authenticate yourself') }}
                    </v-stepper-step>
                    <v-stepper-step :complete="supportStep2Complete" step="2">
                        {{ $gettext('Choose an Account') }}
                    </v-stepper-step>
                </v-stepper-header>
                <v-stepper-items>
                    <v-stepper-content step="1">
                        <v-text-field
                            :label="$gettext('Username')"
                            :placeholder="$gettext('Username')"
                            required
                            v-model="supportUsername"
                            :rules="[v => !!v || $gettext('Username is required')]"
                            outlined
                            clearable
                            class="py-2"
                        ></v-text-field>

                        <v-text-field
                            :label="$gettext('Password')"
                            :placeholder="$gettext('Password')"
                            required
                            v-model="supportPassword"
                            :rules="[v => !!v || $gettext('Password is required')]"
                            outlined
                            clearable
                            class="py-2"
                            type="password"
                        ></v-text-field>

                    </v-stepper-content>
                    <v-stepper-content step="2">
                        <!-- v-if helps with the validation -->

<!--                        :item-text="item => `${item.FTP} (${item.Maker})`"-->
<!--                        :item-key="item => `${item.FTP} (${item.Maker})`"-->

                        <v-autocomplete
                            v-if="supportStep1Complete"
                            v-model="supportChosenClient"
                            :items="supportClients"
                            item-text="clientName"
                            item-key="clientName"
                            outlined
                            :rules="[v => !!v || $gettext('Please select an account')]"
                            class="py-2"
                            required
                            :label="$gettext('Choose an account to manage')"
                            :placeholder="$gettext('Choose an account to manage')"
                        ></v-autocomplete>

                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </v-col>
    </v-row>
</template>
<style type="text/scss">

</style>
<script>

import {storeToRefs} from "pinia";
import {useLoginStore} from "@/stores/LoginStore";
import {ref} from "vue";

export default {
    name: 'SupportModeLoginForm',
    setup() {

        const loginStore = useLoginStore()

        const {
            supportUsername,
            supportPassword,
            supportStepTracker,
            supportStep1Complete,
            supportStep2Complete,
            supportClients,
            supportChosenClient
        } = storeToRefs(loginStore);

        return {
            supportUsername,
            supportPassword,
            supportStepTracker,
            supportStep1Complete,
            supportStep2Complete,
            supportClients,
            supportChosenClient
        }

    }
}


</script>
